import { Box, Skeleton } from "@mui/material";
import Loader from "../../Components/Loader/Loader";
const SkeletonLayout = () => {
    return (
        <Box sx={{ display: "flex", height: "100vh", width: "100%" }}>
            {/* Sidebar */}
            <Box
                sx={{
                    width: 50,
                    bgcolor: (theme) =>
                      theme.palette.sidebar?.main ||
                      (theme.palette.primary?.main?.includes("#c59b27") ? "#30312d" : theme.palette.primary.main),
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    py: 2,
                }}
            >

            </Box>

            {/* Main Content */}
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                {/* Topbar */}
                <Box
                    sx={{
                        height: 60,
                        px: 3,
                        py: 1,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        bgcolor: "background.paper",
                    }}
                >
                    {/* Left Side (Title) */}
                    <Box>
                        <Skeleton variant="text" width={120} height={30} />
                    </Box>

                    {/* Right Side (Actions + Profile) */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Skeleton variant="circular" width={30} height={30} />
                        <Skeleton variant="circular" width={40} height={40} />
                    </Box>
                </Box>

                {/* Table Skeleton */}
                <Box
                    sx={{
                        flex: 1,
                        ml: 2,
                        mt: 2,
                        backgroundColor: "#ffff",
                        borderRadius: 2,
                        boxShadow: 1,
                    }}
                >
                    <Loader />
                </Box>
            </Box>
        </Box>
    );
};

export default SkeletonLayout;
